/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Foot_PrivacyInputs */

const en_mk_foot_privacy = /** @type {(inputs: Mk_Foot_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy policy`)
};

const id_mk_foot_privacy = /** @type {(inputs: Mk_Foot_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kebijakan privasi`)
};

/**
* | output |
* | --- |
* | "Privacy policy" |
*
* @param {Mk_Foot_PrivacyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_foot_privacy = /** @type {((inputs?: Mk_Foot_PrivacyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Foot_PrivacyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_foot_privacy(inputs)
	return en_mk_foot_privacy(inputs)
});